// SJ ATELIER - Luxury Micro Interactions v1.0
(function() {
  'use strict';
  
  // ── Intersection Observer for fade-in animations
  function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('sja-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    
    document.querySelectorAll('.card-wrapper, .section-header, [class*="featured-collection"], [class*="announcement"]').forEach(el => {
      el.classList.add('sja-animate');
      observer.observe(el);
    });
  }
  
  // ── Smooth reveal CSS
  function injectAnimationCSS() {
    const style = document.createElement('style');
    style.textContent = `
      .sja-animate {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.7s cubic-bezier(0.4,0,0.2,1), transform 0.7s cubic-bezier(0.4,0,0.2,1);
      }
      .sja-animate.sja-visible {
        opacity: 1;
        transform: translateY(0);
      }
      .card-wrapper:nth-child(2) .sja-animate { transition-delay: 0.1s; }
      .card-wrapper:nth-child(3) .sja-animate { transition-delay: 0.2s; }
      .card-wrapper:nth-child(4) .sja-animate { transition-delay: 0.3s; }
      
      /* Gold hover line animation for nav */
      .header__menu-item > a,
      .header__nav-link {
        position: relative;
        display: inline-block;
      }
      .header__menu-item > a::after,
      .header__nav-link::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 0;
        height: 1px;
        background-color: #C7A46A;
        transition: width 0.35s ease;
      }
      .header__menu-item > a:hover::after,
      .header__nav-link:hover::after { width: 100%; }
      
      /* Stagger animation for product grid */
      .product-grid .card-wrapper:nth-child(1) { animation-delay: 0s; }
      .product-grid .card-wrapper:nth-child(2) { animation-delay: 0.08s; }
      .product-grid .card-wrapper:nth-child(3) { animation-delay: 0.16s; }
      .product-grid .card-wrapper:nth-child(4) { animation-delay: 0.24s; }
      
      /* Luxury focus outline */
      *:focus-visible {
        outline: 1px solid #C7A46A !important;
        outline-offset: 3px !important;
      }
      
      /* Gold cursor accent */
      a:hover, button:hover, [role="button"]:hover {
        cursor: pointer;
      }
      
      /* Header scroll shadow */
      .header-wrapper.scrolled {
        box-shadow: 0 4px 24px rgba(29,29,29,0.08) !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // ── Header scroll effect
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper, .header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }
  
  // ── Image lazy load optimization
  function initLazyImages() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.5s ease';
      img.addEventListener('load', () => {
        img.style.opacity = '1';
      });
      if (img.complete) img.style.opacity = '1';
    });
  }
  
  // ── Wishlist button enhancement
  function enhanceWishlistButtons() {
    document.querySelectorAll('[class*="wishlist"], [aria-label*="wishlist"], [aria-label*="Wishlist"]').forEach(btn => {
      btn.style.color = '#C7A46A';
    });
  }
  
  // ── Initialize all
  function init() {
    injectAnimationCSS();
    initScrollAnimations();
    initHeaderScroll();
    initLazyImages();
    enhanceWishlistButtons();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-run on section change (Shopify theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });
})();